import Responsive from './Responsive';
import SmoothScroll from './SmoothScroll';
// import Accordion from './Accordion';
// import Tab from './Tab';
// import SpNavi from './SpNavi';
import ToTop from './ToTop';
// import DropDownMenu from './DropDownMenu';
// import BlockLink from './BlockLink';
// import Gmap from './Gmap';
import bowser from 'bowser';
// import matchheight from 'jquery-match-height';
// import link_icon from './link_icon';
import inview from 'jquery-inview';
import FloatAnimation from './FloatAnimation';
import slick from 'slick-carousel';

if(bowser.msie === true) {
	let version = 'ie_'+Math.floor(bowser.version);
	$('body').addClass('ie '+version);
}else if(bowser.msedge === true){
	$('body').addClass('edge');
}else if(bowser.firefox === true){
	$('body').addClass('ff');
}else if(bowser.tablet === true){
	$('body').addClass('tablet');
}

if(bowser.mobile === true){
	$('body').addClass('device--mobile');
	if(bowser.android === true) {
		$('body').addClass('device--mobile--android');
	}
}

let os, ua = navigator.userAgent;
if (ua.match(/Win(dows )?NT 10\.0/)) {
	os = "win10";
}
else if (ua.match(/Win(dows )?NT 6\.3/)) {
	os = "win8_1";
}
else if (ua.match(/Win(dows )?NT 6\.2/)) {
	os = "win8";
}
else if (ua.match(/Win(dows )?NT 6\.1/)) {
	os = "win7";
}else{
	os = '';
}

$('body').addClass(os);
/* ===============================================
Check responsive state
=============================================== */
// const r = new Responsive();

// $(window).on('resize',function(){
// check is responsive;
// 	console.log(r.state()());
// });
// check is mobile;
// alert(r.isPhone());

/* ===============================================
Smooth Scroll
=============================================== */
const sms = new SmoothScroll();
sms.exec();
/* ===============================================
To Top
show/hide toggle
=============================================== */
// let param = {
// 	target : ".float_nav_area",
// 	stop_at : ".global_footer",
// 	fixer : 400,
// 	stop:false
// };

// const totop = new ToTop(param);
// totop.exec();

// let param_won = {
// 	target : "#wovn-translate-widget",
// 	stop_at : ".global_footer",
// 	fixer : 400,
// 	stop:false
// };

// const totop_won = new ToTop(param_won);
// totop_won.exec();


/* ===============================================
#	global header
=============================================== */
const _w = $(window);
_w.on("load scroll",function(){
	let header = $(".js-global_header"),
		mvHeight = $(".mv").height(),
		scroll = $(this).scrollTop();
	if(scroll > mvHeight){
		header.addClass("is-show");
		$('#wovn-translate-widget').addClass('-is-display');
	}else{
		header.removeClass("is-show");
		$('#wovn-translate-widget').removeClass('-is-display');
	}
});




/* ===============================================
#	img lazyload
=============================================== */
$(function(){
	$(".js-lazyload").lazyload({
		effect : 'fadeIn',
		effect_speed: 3000
	});
});

/* ===============================================
#	inview
=============================================== */

/**/
// 最初に、ビューポートの高さを取得し、0.01を掛けて1%の値を算出して、vh単位の値を取得
let vh = window.innerHeight * 0.01;
// カスタム変数--vhの値をドキュメントのルートに設定
document.documentElement.style.setProperty('--vh', `${vh}px`);


// const lct = $('.left-col').offset().top;
// const lch = $('.left-col').height();
// const lcb = lct + lch;
// $(window).on('resize load',function(){

// 	$('.left-col').css('bottom','');
// 	$('.left-col').css('position','');
// 	$('.left-col').css('top','');
// 	//各値を取得
// 	let wh = $(window).height();
// 	let ww = $(window).width();
// 	let ftt = $('.global_footer').offset().top;
// 	let fth = $('.global_footer').height();
// 	let ftb = ftt + fth;

// 	$(window).on('scroll',function(){

// 		if(ww >= 769) {
// 			let ws = $(window).scrollTop();
// 			let wh = $(window).height();
// 			let wb = ws + wh; //window下
// 			if(wb >= lcb) {
// 				$('.left-col').addClass('_fix');
// 			}else{
// 				$('.left-col').removeClass('_fix');
// 			}
// 			if(wb >= ftt) {
// 				if(wh <= lcb){
// 					$('.left-col').css({
// 						'position':'absolute',
// 						'bottom': fth
// 					})
// 				}else{
// 					let lcit = $('.left-col-img').offset().top;
// 					let lcih = $('.left-col-img').height();
// 					let lcib = lcit + lcih;
// 					if(lcib >= ftt) {
// 						$('.left-col').css({
// 							'position':'absolute',
// 							'bottom': fth,
// 							'top':''
// 						})
// 					}
// 				}
// 			}else{
// 				if(wh <= lch){
// 					$('.left-col').css({
// 						'bottom':'0'
// 					})
// 					if($('.left-col').hasClass('_fix')){
// 						$('.left-col').css({
// 							'position':'fixed'
// 						})
// 					}else{
// 						$('.left-col').css({
// 							'position':''
// 						})
// 					}
// 				}else{
// 					$('.left-col').css({
// 						'top':'0'
// 					})
// 					if($('.left-col').hasClass('_fix')){
// 						$('.left-col').css({
// 							'position':'fixed'
// 						})
// 					}else{
// 						$('.left-col').css({
// 							'position':'',
// 							'top':''
// 						})
// 					}
// 				}
// 			}
// 		}
// 	})
// })

// $(window).on('resize load',function(){
// 	let wh = $(window).height();
// 	let ww = $(window).width();
// 	if(ww >= 768) {
// 		switch(true) {
// 			case 700 <= wh && wh <= 800:
// 				$('.mv-logo').css('margin','20vh auto 0');
// 				break;
// 			case 630 <= wh && wh <= 700:
// 				$('.mv-logo').css('margin','15vh auto 0');
// 				break;
// 			case 590 <= wh && wh <= 630:
// 				$('.mv-logo').css('margin','10vh auto 0');
// 				break;
// 			case 560 <= wh && wh <= 590:
// 				$('.mv-logo').css('margin','5vh auto 0');
// 				break;
// 			case 0 <= wh && wh <= 560:
// 				$('.mv-logo').css('margin','0vh auto 0');
// 				break;
// 			default:
// 				$('.mv-logo').css('margin','');
// 		}
// 	}
// })

// $(window).on('resize load',function(){
// 	let ww = $(window).width(),
// 		wh = $(window).height(),
// 		wh_i = $(window).innerHeight();
// 	if(700 <= ww && ww <= 768) {
// 		if(wh >= 0) {
// 			$('.mv').css('height', wh - (wh - wh_i));
// 		}else{
// 			$('.mv').css('height', wh_i);
// 		}
// 	}
// })

/* ===============================================
#	mv control
=============================================== */
_w.on("load resize scroll",function(){

	/* fixed
	----------------------------- */

	let scrl = _w.scrollTop();
	let winH = _w.height();
	let footerY = $("#history").offset().top;
	// console.log({scrl,winH,footerY});
	if(scrl + winH > footerY){
		$(".js-leftCol").css({
			top: -(scrl + winH - footerY)
		});
	}else{
		$(".js-leftCol").css({
			top:0,
		});
	}

	/* arrow fade in/out
	----------------------------- */

	let mainContentsY = $(".js-mv_arrow_trigger").offset().top;
	if(scrl < mainContentsY){
		$(".js-leftCol_arrow").fadeIn();
	}else{
		$(".js-leftCol_arrow").fadeOut();
	}
});


/* ===============================================
#	ロード時フェードイン
=============================================== */
$(window).on("load",function(){
	$("#wrap").animate({opacity:1},1500);
})

/* ===============================================
#	スクロール
=============================================== */
// $(".js-hero-scroll").on("click", function() {
// 	let heroHeight = $(".p-homeMv").height();
// 	$("html,body").animate({ scrollTop: heroHeight }, 800, "swing");
// });

let param = {
	target: ".c-floatNav",
	// stop_at: "",
	fixer: 400
};

const totop = new ToTop(param);
totop.exec();

let param_won = {
	target: "#wovn-translate-widget",
	// stop_at: ".l-footerimg",
	fixer: 400
};

const totop_won = new ToTop(param_won);
totop_won.exec();

/* ===============================================
#	footer float nav
=============================================== */
$(document).ready(function() {
	$(window).on("scroll", function() {
		let scrollHeight;
		let scrollPosition;
		let footHeight;
		scrollHeight = $(document).height(); //ドキュメントの高さ
		scrollPosition = $(window).height() + $(window).scrollTop(); //現在地
		footHeight =
			$(".p-footerContact").innerHeight() +
			$(".l-globalFooter").innerHeight() +
			2; //footerの高さ（＝止めたい位置）
		if (scrollHeight - scrollPosition <= footHeight) {
			//ドキュメントの高さと現在地の差がfooterの高さ以下になったら
			$(".c-floatNav,#wovn-translate-widget").css({
				position: "absolute",
				bottom: footHeight
			});
		} else {
			$(".c-floatNav,#wovn-translate-widget").css({
				position: "fixed"
			});
		}
	});
});